import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../utils/auth';
import { logoutSuccess } from '../authReducer';
import { Input, Icon, Grid, Dropdown, Image, Modal } from 'semantic-ui-react';
import CreateStake from '../CreateStake/CreateStake';
import StakeTile from './StakeTile';

import logo from '../../assets/logo.svg';
import './Home.css';
import 'animate.css';

class Home extends Component {
  static propTypes = {
    userProfile: PropTypes.object.isRequired
  };

  logout = () => {
    logout();
    this.props.dispatch(logoutSuccess());
  };

  render() {
    const { userProfile, allStakes } = this.props;

    allStakes.sort((a, b) => b.lastUpdated - a.lastUpdated);

    return (
      <div id="home">
        <Grid className="nav" columns={3}>
          <Grid.Column floated="left" width={3}>
            <div className="profile">
              <Dropdown
                trigger={
                  <span>
                    <Image src={userProfile.picture} avatar />
                  </span>
                }
                options={[
                  { key: 'account', text: <strong>{userProfile.name}</strong>, disabled: true },
                  { key: 'user', text: 'Accounts', icon: 'user', disabled: true },
                  { key: 'settings', text: 'Settings', icon: 'settings', disabled: true },
                  { key: 'sign-out', text: 'Sign Out', icon: 'sign out', onClick: this.logout }
                ]}
                pointing="top left"
                icon={null}
              />
            </div>
            {/* <Icon link name="user" size="large" title="Login" onClick={this.login} /> */}
          </Grid.Column>
          <Grid.Column width={2}>
            <div className="logo">
              <Image src={logo} />
            </div>
          </Grid.Column>
          <Grid.Column floated="right" width={3}>
            <Modal
              trigger={
                <Icon.Group size="large" id="new-stake" title="Create new Stake">
                  <Icon link name="trophy" />
                  <Icon link corner name="add" />
                </Icon.Group>
              }
              defaultOpen={this.props.location.search === "?draft=1"}
              closeIcon
              dimmer="inverted"
              className="animated slideInUp fadeOut"
              style={{ animationDuration: '0.65s' }}
            >
              <Modal.Content>
                <CreateStake user={userProfile} />
              </Modal.Content>
            </Modal>
          </Grid.Column>
        </Grid>
        <Input icon="search" fluid placeholder="Search..." />

        {allStakes.filter(x => !x.isBeingEdited).map(x => <StakeTile key={x.id} stake={x} user={userProfile} />) }

        {allStakes.length < 2 && (
          <div className="middle">
            <Icon name="tasks" />
            <div className="my-stakes">My Stakes</div>
            <div className="sub">Create a new stake!</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ auth, app }) => ({
  userProfile: auth.profile,
  allStakes: [...app.myStakes, ...app.challengedStakes]
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/App/Home/Home.js